import { Navigate, Outlet, useLocation } from "react-router";
import { isAuthenticated } from "@/store/auth-store";

interface ProtectedRouteProps {
  redirectPath?: string;
}

export const ProtectedRoute = ({
  redirectPath = "/login",
}: ProtectedRouteProps) => {
  const location = useLocation();

  // If User Unauthenticated Redirect to login page but save the attempted location , else render child routes
  return isAuthenticated() ? (
    <Outlet />
  ) : (
    <Navigate to={redirectPath} state={{ from: location }} replace />
  );
};
